import { render, staticRenderFns } from "./StructuredDataBlog.vue?vue&type=template&id=398d9688"
import script from "./StructuredDataBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuredDataBlog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports